import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useT } from '../../../../../../_metronic/i18n/Metronici18n'
import { formatDateTime } from '../../../../../../_metronic/helpers/crud-helper/helpers'
import { TableCard } from '../../../../../components/Table/TableCard'
import { InfoAlert } from '../../../../../components/Info/InfoAlert'
import { CriarRascunhoButton } from '../../acoes/CriarRascunhoButton'
import { CLASSE_LINK_OUTLINE } from '../../core/classeLinkOutline'
import { SituacaoProtocoloBadge } from '../../components/SituacaoProtocoloBadge'
import { useVersoesProtocolo } from '../core/useVersoesProtocolo'
import { aprovadoPor } from '../core/_formato'

/**
 * Bloco acima da tabela: a versão vigente em destaque ou, sem vigente, o aviso com a ação de
 * criar rascunho a partir do modelo Lauduz.
 */
export const VersaoVigente: FC = () => {
  const { t } = useT()
  const { vigente, idEmpresa, acoes, modelo, isLoading, isError } = useVersoesProtocolo()

  if (isLoading || isError) return null

  if (!vigente) {
    return (
      <div role='status'>
        <InfoAlert
          variant='warning'
          title={t('protocolos_triagem.sem_vigente', undefined, 'Nenhuma versão vigente')}
          action={
            <CriarRascunhoButton
              escopo='modelo'
              idEmpresa={idEmpresa}
              versaoModelo={modelo?.versao}
              podeCriarRascunho={acoes.podeCriarRascunho}
              rotulo={t(
                'protocolos_triagem.criar_rascunho_modelo',
                undefined,
                'Criar rascunho a partir do modelo Lauduz'
              )}
            />
          }
        >
          {acoes.podeCriarRascunho
            ? 'Esta empresa ainda não tem protocolo em vigor. Comece por um rascunho a partir do modelo Lauduz.'
            : 'Esta empresa ainda não tem protocolo em vigor.'}
        </InfoAlert>
      </div>
    )
  }

  const aprovacao = aprovadoPor(vigente)
  const apoio = [
    `Vigente desde ${formatDateTime(vigente.dtInicioVigencia)}`,
    vigente.formulario?.nome && `Formulário: ${vigente.formulario.nome}`,
    aprovacao && `Aprovado por ${aprovacao}`,
  ].filter(Boolean)

  // Mesmo formato do card da versão publicada do modelo: identificação à esquerda (badge, título
  // e uma linha de apoio) e ações à direita; em tela estreita as ações descem.
  return (
    <TableCard className='mb-6'>
      <section
        className='card-body d-flex flex-wrap justify-content-between align-items-center gap-6'
        aria-label='Versão vigente'
      >
        <div className='d-flex align-items-center gap-4 min-w-0'>
          <SituacaoProtocoloBadge situacao={vigente.situacao} />
          <div className='min-w-0'>
            <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
              Versão {vigente.versao} — {vigente.nome}
            </h3>
            <p className='mb-0 fs-7 text-gray-700'>{apoio.join(' · ')}</p>
          </div>
        </div>
        <div className='d-flex flex-wrap align-items-center gap-3'>
          <Link
            className={CLASSE_LINK_OUTLINE}
            to={`/apps/protocolos-triagem/${vigente.id}?empresa=${idEmpresa}`}
          >
            Ver detalhe
          </Link>
          <CriarRascunhoButton
            escopo='versao'
            idEmpresa={idEmpresa}
            idOrigem={vigente.id}
            podeCriarRascunho={acoes.podeCriarRascunho}
            aparencia='principal'
          />
        </div>
      </section>
    </TableCard>
  )
}
